import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import Chimp from '../components/chimpSignupForm.js'

const Footer = () => {
  const data = useStaticQuery(
    graphql`
    query footerQuery {
      markdownRemark(frontmatter: {templateKey: {eq: "footer"}, language: {eq: "en"}}) {
        frontmatter {
          leftColumn {
            leftIcon {
              alternateText
              icon
              link
            }
            middleText
            rightIcon {
              alternateText
              icon
              link
            }
            sidewaysList {
              link
              linkText
            }
          }
          middleColumn {
            leftLinks {
              link
              linkText
            }
            leftTitle
            rightIcons {
              alternateText
              icon
              link
            }
            rightTitle
          }
          rightColumn {
            title
          }
          copyright
          bottomRightImage
          littleList {
            linkText
            link
          }
        }
      }
    }
    `)
  const { leftColumn, middleColumn, rightColumn, copyright, bottomRightImage, littleList } = data?.markdownRemark?.frontmatter || {};

  return (<footer>
    <div className="row justify-content-between" id="footerContentRow">
      <div className="column firstCol">
        <div className="row paragonByJonar">
          <a href={leftColumn?.leftIcon?.link}>
            <img src={leftColumn?.leftIcon?.icon} alt={leftColumn?.leftIcon?.alternateText} id="footerLogoParagonBlue"/>
          </a>
          <p>{leftColumn?.middleText}</p>
          <a href={leftColumn?.rightIcon?.link}>
            <img src={leftColumn?.rightIcon?.icon} alt={leftColumn?.rightIcon?.alternateText} id="footerLogoJonar" />
          </a>
        </div>
      <ul className="sidewaysList">
        {
          (leftColumn?.sidewaysList || []).map((element, index) => (
            <li key={index}><a href={element?.link}>{element?.linkText}</a></li>
          ))
        }
        </ul>
      </div>
      <div className="row middleRow">
      <div className="column" id="getInTouch"><h4>{middleColumn?.leftTitle}</h4>
        <ul>
          {
            (middleColumn?.leftLinks || []).map((element, index) => (
              <li key={index}><a href={element?.link}>{element?.linkText}</a></li>
            ))
          }
        </ul>
      </div>
        <div className="column" id="connect"><h4>{middleColumn?.rightTitle}</h4>
        {
          (middleColumn?.rightIcons || []).map((element, index) => (
            <a key={index} href={element?.link}><img src={element?.icon} className="smPic" alt={element?.alternateText} /></a>
          ))
        }
      </div>
      </div>
      <div className="column"><h4 className="signupHeadline">{rightColumn?.title}</h4>
      <div className="chimpy"><Chimp /></div>
      </div>
    </div>
  <hr />
    <div className="row justify-content-between">
            <p className="copyrightBig">{copyright} {new Date().getFullYear()}</p>
            <p className="copyrightLittle">{copyright} {new Date().getFullYear()}.</p>
          <img src={bottomRightImage} className="footerLogo" alt="Paragon ERP"/>
          <ul className="littleList">
          {
          (littleList || []).map((element, index) => (
            <li key={index}><a href={element?.link}>{element?.linkText}</a></li>
          ))
          }
        </ul>
    </div>
  </footer>)
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer